import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { withTranslation } from "react-i18next";

const COLORS = ["#22C55E", "#EF4444", "#F8CB00", "#9CA3AF"];

class PieChartSummary extends PureComponent {
  render() {
    const { t, statistics } = this.props;

    const data = statistics
      ? [
          {
            name: t("pieChart.status.Confirmed"),
            value: statistics.confirmed?.count,
            percentage: statistics.confirmed?.percentage,
          },
          {
            name: t("pieChart.status.Declined"),
            value: statistics.declined?.count,
            percentage: statistics.declined?.percentage,
          },
          {
            name: t("pieChart.status.Pending"),
            value: statistics.pending?.count,
            percentage: statistics.pending?.percentage,
          },
          {
            name: t("pieChart.status.Cancelled"),
            value: statistics.cancelled?.count,
            percentage: statistics.cancelled?.percentage,
          },
        ]
      : [];

    const totalBookings = statistics
      ? statistics.totalBookings ||
        data.reduce((sum, entry) => sum + (entry.value || 0), 0)
      : 0;

    if (data.length === 0) {
      return <div>{t("pieChart.noData__")}</div>;
    }

    return (
      <div
        style={{ width: "100%", height: "100%" }}
        className="pie-chart-container"
        // dir="rtl" // Ensure the component is displayed in RTL direction
      >
        <ResponsiveContainer width="100%" height="80%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <text
              x="50%"
              y="45%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "15px", fill: "#6B7280" }}
            >
              {t("pieChart.title")}
            </text>
            <text
              x="50%"
              y="58%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "24px", fontWeight: "bold", fill: "#111827" }}
            >
              {totalBookings}
            </text>
          </PieChart>
        </ResponsiveContainer>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            flexWrap: "wrap",
            flexDirection: "row-reverse", // Align items from right to left for RTL
          }}
          className="statistics-cards"
        >
          {data.map((entry, index) => (
            <div
              key={`stat-card-${index}`}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: "0px 20px",
                width: "25%",
                marginTop: "12px",
              }}
              className="statistics-card"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: COLORS[index % COLORS.length],
                    marginLeft: "6px", // Change margin to 'left' for RTL direction
                  }}
                />
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "rgb(15, 23, 42)",
                  }}
                >
                  {entry.name}
                </div>
              </div>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "rgb(17, 24, 39)",
                  marginBottom: "8px",
                  marginTop: "8px",
                }}
              >
                {entry.value || 0}
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "rgb(156, 163, 175)",
                }}
              >
                {entry.percentage || 0}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withTranslation("dash")(PieChartSummary);
